<template lang="pug">
.mypage-link
</template>

<script setup>
    import { getCurrentInstance, onMounted, ref, reactive } from 'vue'
    import { useAuth } from '@/store/auth'
    import { ErrorHelper } from '@/helpers/error'
    import { VueHelper } from '@/helpers/vue'
    import { AlbionIDSite } from '@/models/converter/site-settings-convert'
    import { LINEAuthRedirectCode } from '@/models/converter/line-convert'
    import { GetMembersCardRequest } from '@/models/api/members-card'
    import { PostCardAlignmentSetupRequest } from '@/models/api/card-alignment-setup'
    import { GetLineOauthRequest } from '@/models/api/line-oauth'
    import { PostLineOauthSetupRequest } from '@/models/api/line-oauth-setup'
    import { albionOfficialEcSiteConfig } from '@baseConfig'

    const _this = getCurrentInstance()
    const globalProperties = _this.appContext.config.globalProperties
    const membersCardApi = _this.appContext.config.globalProperties.$membersCardApi
    const cardAlignmentSetupApi = _this.appContext.config.globalProperties.$cardAlignmentSetupApi
    const lineOauthApi = _this.appContext.config.globalProperties.$lineOauthApi
    const lineOauthSetupApi = _this.appContext.config.globalProperties.$lineOauthSetupApi

    const authStore = useAuth()
    const requestInfo = reactive({
        provisionShopCode: null,
        brandSite: null,
        isAuthenticated: false,
        lineId: null,
    })
    const authKey = ref()
    const identityVerificationFlag = ref(false)

    const getParameter = () => {
        requestInfo.provisionShopCode = VueHelper.getParameter(globalProperties, 'provision_shop_code') ?? authStore.LINELoginData.provisionShopCode
    }

    /** Web-LINE認証情報取得API実行 */
    const getLineOauth = async() => {
        const lineOauthRequest = new GetLineOauthRequest(requestInfo.provisionShopCode)
        return await lineOauthApi.getLineOauth(lineOauthRequest).then((response) => {
            if (ErrorHelper.apiErrorAndTimeoutHandler(response, globalProperties)) {
                requestInfo.isAuthenticated = response.data?.is_authenticated ?? false
                if (requestInfo.isAuthenticated) {
                    requestInfo.brandSite = response.data?.brandsite
                    requestInfo.lineId = response.data?.lineid
                }
            }
        })
    }

    /** Web-LINE認証準備API */
    const postLineOauthSetup = async() => {
        const request = new PostLineOauthSetupRequest(
            requestInfo.provisionShopCode,
            LINEAuthRedirectCode.MY_PAGE_LINK.code,
            '',
            requestInfo.brandSite,
        )
        return await lineOauthSetupApi.postLineOauthSetup(request).then((response) => {
            if (ErrorHelper.apiErrorAndTimeoutHandler(response, globalProperties)) {
                if (response.data?.return_to) {
                    location.replace(response.data?.return_to)
                    return
                }
            }
        })
    }

   /** Web-LINE会員証取得API実行 */
    const getWebMembersCard = async() => {
        const request = new GetMembersCardRequest(
            requestInfo.provisionShopCode,
            requestInfo.lineId,
            requestInfo.brandSite,
        )
        return await membersCardApi.getMembersCard(request).then(async(response) => {
            if (ErrorHelper.apiErrorAndTimeoutHandler(response, globalProperties)) {
                const cardNumber = response.data?.data?.card_number
                await authStore.login(requestInfo.provisionShopCode, requestInfo.lineId, requestInfo.brandSite, cardNumber)
            }
        })
    }

    /** Web-連携一意キー発行API実行 */
    const postCardAlignmentSetup = async() => {
        const request = new PostCardAlignmentSetupRequest(
            authStore.LINELoginData.provisionShopCode,
            authStore.LINELoginData.cardNumber,
        )
        return await cardAlignmentSetupApi.postCardAlignmentSetup(request).then((response) => {
            if (ErrorHelper.apiErrorAndTimeoutHandler(response, globalProperties)) {
                authKey.value = response.data?.auth_key
                identityVerificationFlag.value = response.data?.identity_verification_flag
            }
        })
    }

    const init = async() => {
        return await getLineOauth().then(async() => {
            // 認証チェック
            const paramsBrandSite = VueHelper.getParameter(globalProperties, 'brandsite') ?? authStore.LINELoginData.brandSite
            if(requestInfo.isAuthenticated && requestInfo.brandSite == paramsBrandSite) {
                return await getWebMembersCard().then(async() => {
                    return await postCardAlignmentSetup().then(() => {
                        console.log(identityVerificationFlag.value)
                        const uri = identityVerificationFlag.value ? '/customer/identity-verification.aspx' : '/customer/menu.aspx'
                        const url = albionOfficialEcSiteConfig.siteUrl + uri +
                            '?al_card=' + authStore.LINELoginData.cardNumber +
                            '&al_root=1' +
                            '&al_key=' + authKey.value
                        location.replace(url)
                    })
                })
            } else {
                // パラメータと認証済のbrandsiteが異なる場合、再度ログイン処理
                requestInfo.brandSite = paramsBrandSite
                return await postLineOauthSetup()
            }
        })
    }

    onMounted(async() => {
        getParameter()
        const site = AlbionIDSite.findByProvisionShopCode(requestInfo.provisionShopCode)
        if (site == undefined || site == null || !site.config.isUseMembersCard) {
            VueHelper.transitionByLocation(globalProperties, { path: '/error' })
            return
        }
        await init().finally(() => {
            VueHelper.unlock()
        })
    })
</script>

<style scoped lang="stylus">
</style>
